module.exports = __webpack_public_path__ + "img/tiktok-social.8b96c16b.svg";